import styled from "styled-components";

interface AnchorProps {
  name: string;
  smoothScroll?: boolean;
  children?: React.ReactNode;
}

export const Anchor = ({ name, smoothScroll, children }: AnchorProps) => (
  <>
    <AnchorOuter data-is-smoothscroll={smoothScroll}>
      <AnchorInner key={name} id={name} />
    </AnchorOuter>
    {children}
  </>
);

const AnchorOuter = styled.span`
  position: relative;
  height: 0;
  width: 0;
  line-height: 0;
  &[data-is-smoothscroll="true"] {
    scroll-behavior: smooth;
  }
`;
const AnchorInner = styled.span`
  position: absolute;
  top: calc(
    -1 * calc(calc(var(--navigation-height) + var(--solana-status-bar-height)) +
          var(--spacing-md))
  );
  height: 0;
  width: 0;
  line-height: 0;
`;

export default Anchor;
